module.exports = __webpack_public_path__ + "static/media/purchases.fee8e21c.svg";